import React, { useEffect, useState } from "react";
import {
  MDBIcon,
  MDBInput,
  MDBCheckbox,
  MDBSideNavCollapse,
  MDBSideNavItem,
  MDBSideNavLink,
  MDBTooltip,
} from "mdb-react-ui-kit";
import axios from "axios";

const SponsorFilter = ({
  selectedLegislators,
  setSelectedLegislators,
  filterSession,
  filterLegislature,
  legislatorCollapse,
  setLegislatorCollapse,
}) => {
  const [searchSponsor, setSearchSponsor] = useState("");
  const [legislators, setLegislators] = useState([]);

  const handleLegislatorChange = (legislator) => {
    setSelectedLegislators((prev) => {
      const updatedLegislators = prev.legs.some(
        (selected) => selected.id === legislator.id
      )
        ? prev.legs.filter((selected) => selected.id !== legislator.id)
        : [
            ...prev.legs,
            {
              id: legislator.id,
              firstName: legislator.firstName,
              lastName: legislator.lastName,
            },
          ];

      return { ...prev, legs: updatedLegislators };
    });
  };
  const handleRoleChange = (role, isChecked) => {
    setSelectedLegislators((prev) => {
      const updatedRoles = isChecked
        ? [...prev.roles, role]
        : prev.roles.filter((r) => r !== role);

      return { ...prev, roles: updatedRoles };
    });
  };

  // Fetch legislators
  useEffect(() => {
    const fetchLegislators = async () => {
      if (filterSession && filterLegislature) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/search?limit=1000&offset=0`,
            {
              sessionIds: [filterSession.id],
              legislatureIds: [filterLegislature.id],
            }
          );
          const fetchedLegislators = response.data.content || [];
          // Sort alphabetically by lastName, then by firstName
          fetchedLegislators.sort((a, b) => {
            if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) return -1;
            if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) return 1;
            if (a.firstName.toLowerCase() < b.firstName.toLowerCase())
              return -1;
            if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
            return 0;
          });
          // Remove old legislators that still exist in Laws
          const filteredLegislators = fetchedLegislators.filter(
            (leg) => leg.electionStatus !== null
          );
          setLegislators(filteredLegislators);
        } catch (error) {
          console.error("Error fetching legislators:", error);
          setLegislators([]);
        }
      }
    };

    fetchLegislators();
  }, [filterSession, filterLegislature]);
  return (
    <MDBSideNavItem>
      <MDBSideNavLink
        className="accordion-button"
        icon="angle-down"
        shouldBeExpanded={legislatorCollapse}
        onClick={() => setLegislatorCollapse(!legislatorCollapse)}
      >
        Legislator
      </MDBSideNavLink>
      <MDBSideNavCollapse open={legislatorCollapse}>
        <li className="p-3">
          <fieldset className="mb-3 d-flex justify-content-between">
            <legend className="text-danger">Required *</legend>
            <div>
              <MDBCheckbox
                name="roleFilter"
                id="roleSponsor"
                label="Sponsor"
                value="Sponsor"
                onChange={(e) => handleRoleChange("Sponsor", e.target.checked)}
                checked={selectedLegislators.roles.includes("Sponsor")}
              />
              <MDBCheckbox
                name="roleFilter"
                id="roleRequester"
                label="Requester"
                value="Requester"
                onChange={(e) =>
                  handleRoleChange("Requester", e.target.checked)
                }
                checked={selectedLegislators.roles.includes("Requester")}
              />
              <MDBCheckbox
                name="roleFilter"
                id="roleMember"
                label="Member"
                value="Member"
                onChange={(e) => handleRoleChange("Member", e.target.checked)}
                checked={selectedLegislators.roles.includes("Member")}
              />
            </div>
            <div className="text-end">
              <MDBTooltip
                title="Choose one or more types of Legislator relationships to bills/committees to export a specific schedule."
                tag="a"
                color="none"
              >
                <MDBIcon far icon="question-circle" />
              </MDBTooltip>
            </div>
          </fieldset>
          <MDBInput
            type="text"
            label="Search Legislators..."
            value={searchSponsor}
            onChange={(e) => setSearchSponsor(e.target.value)}
          />
          <div
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              border: "1px solid #ddd",
              padding: "10px",
            }}
          >
            {legislators
              .filter(
                (legislator) =>
                  legislator.firstName
                    .toLowerCase()
                    .includes(searchSponsor.toLowerCase()) ||
                  legislator.lastName
                    .toLowerCase()
                    .includes(searchSponsor.toLowerCase())
              )
              .map((legislator) => (
                <MDBCheckbox
                  key={legislator.id}
                  label={`${legislator.lastName}, ${legislator.firstName}`}
                  onChange={() => handleLegislatorChange(legislator)}
                  checked={selectedLegislators.legs.some(
                    (selected) => selected.id === legislator.id
                  )}
                  disabled={selectedLegislators.roles.length === 0}
                />
              ))}
          </div>
        </li>
      </MDBSideNavCollapse>
    </MDBSideNavItem>
  );
};

export default SponsorFilter;
